import React from "react";
import Button from "@mui/material/Button";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Stack from "@mui/material/Stack";
import { LoadingButton } from "@mui/lab";

const INIT_BUTTON_LIST = [
  {
    id: "1",
    name: "Profile",
    path: "/profile",
    icon: "",
    loading: false,
    clickAction: () => {},
  },
  {
    id: "2",
    name: "Logout",
    path: "/logout",
    icon: "",
    loading: false,
    clickAction: () => {},
  },
];

export default function AppDropdownButton({
  mainIcon,
  title,
  ListButtons = INIT_BUTTON_LIST,
}) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    // if (anchorRef.current && anchorRef.current.contains(event.target)) {
    //   return;
    // }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <Stack direction="row" spacing={2}>
      <div>
        <Button
          ref={anchorRef}
          id="composition-button"
          aria-controls={open ? "composition-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          startIcon={mainIcon || null}
          onClick={handleToggle}
        >
          {title || "Dropdown"}
        </Button>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom-start" ? "left top" : "left bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                  >
                    {ListButtons.map((item) => {
                      return (
                        <MenuItem
                          key={item.id}
                          onClick={() => {
                            item.clickAction();
                            handleClose();
                          }}
                        >
                          <LoadingButton
                            loading={item.loading || false}
                            type="button"
                            size="small"
                            title={item.name || ""}
                            variant="text"
                            color="inherit"
                            startIcon={item.icon || null}
                          >
                            {item.name}
                          </LoadingButton>
                        </MenuItem>
                      );
                    })}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </Stack>
  );
}
